import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getMailTemplates = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'name', order: 'ASC' }})
    }

    return filterObjectStore(state.mailTemplate.mailTemplates.entries, filter);
};
